require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2008-12-23-mod-v-8.json") })
        }
      }, "path---articles-2008-12-23-mod-v-8");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2008-12-23-mod-v-8!./.cache/json/articles-2008-12-23-mod-v-8.json
// module id = 560
// module chunks = 231608221292675